module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scheduler"
  }, [_c('ul', {
    staticClass: "scheduler__header"
  }, [_c('li', [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScrollTop),
      expression: "handleScrollTop"
    }],
    ref: "topDiv",
    staticClass: "do-scroller do-scroller--hide"
  }, [_c('ul', {
    staticClass: "scheduler__header__times"
  }, _vm._l((_vm.hoursInLocale), function(number) {
    return _c('li', [_vm._v(_vm._s(_vm.$filters.LT(number)))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "scheduler__container"
  }, [_c('div', {
    staticClass: "do-scroller__container"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScrollLeft),
      expression: "handleScrollLeft"
    }],
    ref: "leftDiv",
    staticClass: "do-scroller do-scroller-max-height do-scroller--hide do-scroller__users"
  }, [_c('ul', {
    staticClass: "scheduler__users"
  }, _vm._l((_vm.itemsSorted), function(item, idx) {
    return _c('li', {
      key: item.id,
      class: {
        'item-is-headline': item.headline
      },
      style: ({
        'height': 40 * _vm.rows[item.id] + 'px'
      })
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "scheduler__cal"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "scheduler__cal--loading"
  }, [_c('Spinner', {
    staticStyle: {
      "margin-top": "-120px"
    },
    attrs: {
      "color": "blue"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "do-scroller__container"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScrollRight),
      expression: "handleScrollRight"
    }],
    ref: "rightDiv",
    staticClass: "do-scroller do-scroller-max-height do-scroller--hide"
  }, [_c('ul', {
    staticClass: "scheduler__cal__ress"
  }, [_c('ul', {
    staticClass: "scheduler__cal__ress__items"
  }, _vm._l((_vm.itemsSorted), function(item) {
    return _c('SchedulerItem', {
      key: item.id,
      attrs: {
        "user": item
      },
      on: {
        "rows": function($event) {
          return _vm.setRows($event, item.id)
        }
      }
    })
  }), 1), _vm._v(" "), _c('ul', {
    staticClass: "scheduler__cal__timeslots"
  }, _vm._l((_vm.hoursInLocale.length * 2), function(n) {
    return _c('li')
  }), 0)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70fdd330!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DScheduler/DScheduler.vue
// module id = 2004
// module chunks = 1